import { useEffect } from 'react';

import { recordJourneyPageExit } from './journeySteps';

/**
 * `pagehide` fires before the visibility change on which the Datadog SDK
 * flushes, so the marker rides the final beacon.
 */
export function useJourneyPageExit() {
  useEffect(function recordPageExit() {
    const onPageHide = () => {
      recordJourneyPageExit();
    };
    window.addEventListener('pagehide', onPageHide);
    return () => window.removeEventListener('pagehide', onPageHide);
  }, []);
}
